// assets/react/fox-lightbox.js
import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

const FoxLightbox = () => {
	const [open, setOpen] = useState(false);
	const [slides, setSlides] = useState([]);
	const [currentIndex, setCurrentIndex] = useState(0); // Add currentIndex state

	// Open the lightbox with dynamic content from vanilla JS
	window.openFoxLightbox = (newSlides, startIndex = 0) => {
		console.log("Setting slides: ", newSlides);  // For debugging purposes
		setSlides(newSlides); // Set the new slides
		setCurrentIndex(startIndex); // Set the starting index
		setOpen(true); // Open the lightbox
	};

	// Custom renderer for custom slides (HTML content)
	const customSlideRenderer = ({ slide }) => {
		if (slide.type === 'custom-slide') {
			return (
				<div
					className="custom-slide-content"
					dangerouslySetInnerHTML={{ __html: slide.content }}  // Insert HTML content
				/>
			);
		}
		return null;  // Regular image slides will be handled automatically
	};

	return (
		<Lightbox
			open={open}
			close={() => setOpen(false)}
			slides={slides} // Make sure slides are passed directly
			render={{ slide: customSlideRenderer }}  // Render custom HTML slides if applicable
			index={currentIndex} // Set the starting index of the lightbox
			carousel={{ finite: slides.length <= 1 }}
		/>
	);
};

export default FoxLightbox;
